module.exports = __webpack_public_path__ + "img/capibara.639d925c.png";